import fJj8xk from "./fJj8xk";
import keyMsgJson from "../json/keymsg.json";

let defaultUrl =
    "https://prod-gateway.ehbapp.hubei.gov.cn/81685271ce2347b5b23ad301a81da546",
  defaultHeader = {
    "X-hbzw-Api-Key": "595a1078-89aa-4ff0-bbaa-17e286913657",
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
  },
  defaultParam = {
    appkey: "8409DA7155693365E0532900440A4AC8",
    token: keyMsgJson.token
  },
  key = keyMsgJson.key;

export default {
  post(data) {
    return new Promise((resolve, reject) => {
      let param = { ...defaultParam, ...data };
      hbzwfwJssdk.network.request({
        url: defaultUrl,
        type: "post",
        data: {
          input: fJj8xk.EncryptByKey(JSON.stringify(param), key)
        },
        headers: defaultHeader,
        success: function(res) {
          resolve(fJj8xk.DecryptByKey(JSON.parse(res).result, key))
        },
        fail: function(err) {
          console.log(err);
          reject(err);
        }
      });
    }).catch((error)=>{
      console.error(error);
    });
  },
  get(data) {
    return new Promise((resolve, reject) => {
      let param = { ...defaultParam, ...data };
      hbzwfwJssdk.network.request({
        url: defaultUrl,
        type: "get",
        data: {
          input: fJj8xk.EncryptByKey(JSON.stringify(param), key)
        },
        headers: defaultHeader,
        success: function(res) {
          resolve(JSON.parse(fJj8xk.DecryptByKey(res.data.result, key)));
        },
        fail: function(res) {
          // console.log(err);
          reject(err);
        }
      });
    }).catch((error)=>{
      console.error(error);
    })
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/aesRequest.js